export default () => {

    window.addEventListener('DOMContentLoaded',function () {
        stroke()

        const strokeText = document.querySelectorAll(".afterparty-stroke__text")

        strokeText.forEach(function (text) {
            text.classList.add('animation')
        })


    })

    window.addEventListener('resize', stroke)

    function stroke() {
        const titleWidth = document.querySelector(".afterparty__title").getBoundingClientRect().width
        const strokeBlock = document.querySelectorAll(".afterparty-stroke")


        strokeBlock.forEach(function (stroke) {
            stroke.style.width = `calc(49% - ${titleWidth / 2}px)`
        })
    }
};
